import { AutoMap } from "@automapper/classes";
import { Temporal } from "@js-temporal/polyfill"

export class MeasureMassif {
    @AutoMap()
    Code!: string;
    @AutoMap()
    SamplingId!: number;
    @AutoMap()
    SamplingTime?: Temporal.PlainTime;
    @AutoMap()
    Localisation?: string;
    @AutoMap()
    ScolaMaterial?: string;
    @AutoMap()
    PrelevementEffectue?: boolean;
    @AutoMap()
    SampleCode?: string;
}